import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * A pure layout route — its only job is to be the parent TanStack Router
 * needs for `/services/$serviceId/import` to nest under. The actual
 * schedule table page lives at the index child (`services.$serviceId.
 * index.tsx`), not here: this component used to render that page's full
 * content directly, which meant `/import` could never display anything —
 * without an `<Outlet />` in the parent, a child route's component never
 * mounts, no matter how correctly it's registered.
 */
export const Route = createFileRoute("/services/$serviceId")({
  component: Outlet,
});
